import { Long } from "../../../helpers";
import * as _m0 from "protobufjs/minimal";
import { fromBase64, toBase64 } from "@cosmjs/encoding";
/**
 * UploadCosmWasmPoolCodeAndWhiteListProposal is a gov Content type for
 * uploading coswasm pool code and adding it to internal whitelist. Only the
 * code ids created by this message are eligible for being x/cosmwasmpool pools.
 */

function createBaseUploadCosmWasmPoolCodeAndWhiteListProposal() {
  return {
    title: "",
    description: "",
    wasmByteCode: new Uint8Array()
  };
}

export const UploadCosmWasmPoolCodeAndWhiteListProposal = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.UploadCosmWasmPoolCodeAndWhiteListProposal",

  encode(message, writer = _m0.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    if (message.wasmByteCode.length !== 0) {
      writer.uint32(26).bytes(message.wasmByteCode);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadCosmWasmPoolCodeAndWhiteListProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          message.wasmByteCode = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title, _object$description, _object$wasmByteCode;

    const message = createBaseUploadCosmWasmPoolCodeAndWhiteListProposal();
    message.title = (_object$title = object.title) !== null && _object$title !== void 0 ? _object$title : "";
    message.description = (_object$description = object.description) !== null && _object$description !== void 0 ? _object$description : "";
    message.wasmByteCode = (_object$wasmByteCode = object.wasmByteCode) !== null && _object$wasmByteCode !== void 0 ? _object$wasmByteCode : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      wasmByteCode: fromBase64(object.wasm_byte_code)
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;
    obj.wasm_byte_code = message.wasmByteCode ? toBase64(message.wasmByteCode) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return UploadCosmWasmPoolCodeAndWhiteListProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/upload-cosm-wasm-pool-code-and-white-list-proposal",
      value: UploadCosmWasmPoolCodeAndWhiteListProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return UploadCosmWasmPoolCodeAndWhiteListProposal.decode(message.value);
  },

  toProto(message) {
    return UploadCosmWasmPoolCodeAndWhiteListProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.UploadCosmWasmPoolCodeAndWhiteListProposal",
      value: UploadCosmWasmPoolCodeAndWhiteListProposal.encode(message).finish()
    };
  }

};

function createBaseMigratePoolContractsProposal() {
  return {
    title: "",
    description: "",
    poolIds: [],
    newCodeId: Long.UZERO,
    wasmByteCode: new Uint8Array(),
    migrateMsg: new Uint8Array()
  };
}

export const MigratePoolContractsProposal = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.MigratePoolContractsProposal",

  encode(message, writer = _m0.Writer.create()) {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }

    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }

    writer.uint32(26).fork();

    for (const v of message.poolIds) {
      writer.uint64(v);
    }

    writer.ldelim();

    if (!message.newCodeId.isZero()) {
      writer.uint32(32).uint64(message.newCodeId);
    }

    if (message.wasmByteCode.length !== 0) {
      writer.uint32(42).bytes(message.wasmByteCode);
    }

    if (message.migrateMsg.length !== 0) {
      writer.uint32(50).bytes(message.migrateMsg);
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMigratePoolContractsProposal();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.title = reader.string();
          break;

        case 2:
          message.description = reader.string();
          break;

        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;

            while (reader.pos < end2) {
              message.poolIds.push(reader.uint64());
            }
          } else {
            message.poolIds.push(reader.uint64());
          }

          break;

        case 4:
          message.newCodeId = reader.uint64();
          break;

        case 5:
          message.wasmByteCode = reader.bytes();
          break;

        case 6:
          message.migrateMsg = reader.bytes();
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    var _object$title2, _object$description2, _object$poolIds, _object$wasmByteCode2, _object$migrateMsg;

    const message = createBaseMigratePoolContractsProposal();
    message.title = (_object$title2 = object.title) !== null && _object$title2 !== void 0 ? _object$title2 : "";
    message.description = (_object$description2 = object.description) !== null && _object$description2 !== void 0 ? _object$description2 : "";
    message.poolIds = ((_object$poolIds = object.poolIds) === null || _object$poolIds === void 0 ? void 0 : _object$poolIds.map(e => Long.fromValue(e))) || [];
    message.newCodeId = object.newCodeId !== undefined && object.newCodeId !== null ? Long.fromValue(object.newCodeId) : Long.UZERO;
    message.wasmByteCode = (_object$wasmByteCode2 = object.wasmByteCode) !== null && _object$wasmByteCode2 !== void 0 ? _object$wasmByteCode2 : new Uint8Array();
    message.migrateMsg = (_object$migrateMsg = object.migrateMsg) !== null && _object$migrateMsg !== void 0 ? _object$migrateMsg : new Uint8Array();
    return message;
  },

  fromAmino(object) {
    return {
      title: object.title,
      description: object.description,
      poolIds: Array.isArray(object === null || object === void 0 ? void 0 : object.pool_ids) ? object.pool_ids.map(e => e) : [],
      newCodeId: Long.fromString(object.new_code_id),
      wasmByteCode: fromBase64(object.wasm_byte_code),
      migrateMsg: object.migrate_msg
    };
  },

  toAmino(message) {
    const obj = {};
    obj.title = message.title;
    obj.description = message.description;

    if (message.poolIds) {
      obj.pool_ids = message.poolIds.map(e => e);
    } else {
      obj.pool_ids = [];
    }

    obj.new_code_id = message.newCodeId ? message.newCodeId.toString() : undefined;
    obj.wasm_byte_code = message.wasmByteCode ? toBase64(message.wasmByteCode) : undefined;
    obj.migrate_msg = message.migrateMsg;
    return obj;
  },

  fromAminoMsg(object) {
    return MigratePoolContractsProposal.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/migrate-pool-contracts-proposal",
      value: MigratePoolContractsProposal.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return MigratePoolContractsProposal.decode(message.value);
  },

  toProto(message) {
    return MigratePoolContractsProposal.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.MigratePoolContractsProposal",
      value: MigratePoolContractsProposal.encode(message).finish()
    };
  }

};